import { makeStyles } from '@material-ui/core/styles';
import variables from '../Sys/variable.scss';

export const surfaceShadow = '0 8px 24px rgba(12, 41, 84, 0.055)';

export const brandGradient = `linear-gradient(90deg, ${variables.primaryColor || '#3D7DDD'}, #8b5cf6, #22c55e)`;

export const pageEyebrowStyles = {
  color: variables.primaryColor || '#3D7DDD',
  fontSize: '0.7rem',
  fontWeight: 800,
  letterSpacing: '0.09em',
  textTransform: 'uppercase',
};

export const pageTitleTextStyles = {
  color: 'var(--dm-text-strong, #263548)',
  fontSize: 'clamp(1.375rem, 2.4vw, 1.75rem)',
  fontWeight: 750,
  letterSpacing: '-0.025em',
  lineHeight: 1.25,
  wordBreak: 'break-word',
};

export const pageTitleStyles = {
  ...pageTitleTextStyles,
  '&::after': {
    content: '""',
    display: 'block',
    width: 44,
    height: 4,
    marginTop: 10,
    borderRadius: 4,
    background: brandGradient,
  },
};

export const surfaceCardStyles = {
  backgroundColor: 'var(--contentColor, #fff)',
  border: '1px solid var(--dm-border, #e7ebf0)',
  borderRadius: 16,
  boxShadow: surfaceShadow,
};

export const interactiveCardStyles = {
  ...surfaceCardStyles,
  transition: 'transform 180ms ease-out, border-color 180ms ease-out, box-shadow 180ms ease-out',
  '&:hover': {
    transform: 'translateY(-2px)',
    borderColor: variables.primaryColor || '#3D7DDD',
    boxShadow: '0 12px 28px rgba(12, 41, 84, 0.09)',
  },
  '@media (prefers-reduced-motion: reduce)': {
    transition: 'none',
    '&:hover': { transform: 'none' },
  },
};

export const iconWellStyles = {
  borderRadius: 10,
  border: 0,
  backgroundColor: 'rgba(61, 125, 221, 0.1)',
  color: variables.primaryColor || '#3D7DDD',
};

export const commonStyles = {
  contentWrapper: {
    background: 'var(--contentColor, #fff)',
    color: 'var(--dm-text-strong, #263548)',
    boxShadow: surfaceShadow,
    border: '1px solid var(--dm-border, #e7ebf0)',
    borderRadius: 16,
    padding: 24,
    maxWidth: '100%',
    boxSizing: 'border-box',
    '@media (max-width: 374px)': {
      padding: 16,
    },
  },
  pageTitle: {
    ...pageTitleStyles,
    marginBottom: 20,
  },
  pagination: {
    margin: '0 auto',
    '& .MuiPaginationItem-root': {
      borderColor: 'var(--dm-border, #e7ebf0)',
      color: 'var(--dm-muted, #647184)',
      fontWeight: 600,
      borderRadius: 8,
    },
    '& .MuiPaginationItem-outlinedPrimary.Mui-selected, & .MuiPaginationItem-page.Mui-selected': {
      backgroundColor: `${variables.primaryColor || '#3D7DDD'} !important`,
      borderColor: `${variables.primaryColor || '#3D7DDD'} !important`,
      color: '#fff !important',
    },
  },
};

export default makeStyles((theme) => commonStyles);
